import styles from "./introductionHeader.module.scss";
import React, { useEffect, useState } from "react";

export default function IntroductionHeader() {
  const colorfulWord = [
    {
      id: 1,
      name: " experience ",
      startingSentence: "deeply catching all",
      endingSentence: "I can find in various positions",
      duration: 7000,
      color: "blueColor",
    },
    {
      id: 2,
      name: " stunning ",
      startingSentence: "delivering",
      endingSentence: "user experiences",
      duration: 9000,
      color: "purpleColor",
    },
    {
      id: 3,
      name: " attention ",
      startingSentence:
        "delivering Top-notch solutions through technical expertise and",
      endingSentence: "to detail",
      duration: 5000,
      color: "goldColor",
    },
  ];

  const [index, setIndex] = useState(0);
  const [currentColorfulWord, setCurrentColorfulWord] = useState(
    colorfulWord[index]
  );

  useEffect(() => {
    setCurrentColorfulWord(colorfulWord[index]);
  }, [index]);

  useEffect(() => {
    setTimeout(() => {
      setIndex(index === colorfulWord.length - 1 ? 0 : index + 1);
    }, currentColorfulWord.duration);
  }, [currentColorfulWord]);

  return (
    <>
      <div className={styles.pageLayout}>
        <div className={styles.wrapper}>
          <div className={styles.introText}>
            Hello, I'm a{" "}
            <span id={styles[currentColorfulWord.color]}>Front-End</span>{" "}
            developer {currentColorfulWord.startingSentence}
            <span id={styles.greenColor}>{currentColorfulWord.name}</span>
            {currentColorfulWord.endingSentence}
          </div>
          <div className={styles.introPhoto}></div>
        </div>
      </div>
    </>
  );
}
